import React from 'react';
import PropTypes from 'prop-types';

function stopPropagation(WrappedComponent) {
  return class extends React.Component {
    onClick = (e) => {
      e.stopPropagation();

      if (this.props.onClick) {
        this.props.onClick(e);
      }
    };

    render() {
      return <WrappedComponent {...this.props} onClick={this.onClick} />;
    }
  };
}
stopPropagation.propTypes = {
  onClick: PropTypes.func,
};
stopPropagation.defaultProps = {
  onClick: null,
};

const stopPropagationHandler = (e) => e.stopPropagation();

export { stopPropagation, stopPropagationHandler };
